// extracted by mini-css-extract-plugin
export default {"note":"Note_note__pPWeU","text":"Note_text__uUd5d"};